import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UserType } from "@shared-features/enums/user-type.enum";
import { TabIndex } from "@shared/enums/tab-index.enum";
import { CustomerTabConfig } from "@shared-features/enums/customer-tab-config.enum";
import { TabGroup } from "@shared/enums/tab-group.enum";
import { TabNavigationService } from '@shared/services/tab-navigation.service';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],

})
export class AddUserComponent {
  @Input() userType: UserType;
  @Input() id: number;
  @Output() redirectTo = new EventEmitter();

  constructor(private router: Router, private tabNavigationService: TabNavigationService){}

  handleCloseEvent() {
    this.redirectTo.emit();
    if (this.router.url.includes('fleet')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.Provider, index: TabIndex.ProviderUsers });
    } else if (this.router.url.includes('customer')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.Customer, index: CustomerTabConfig.users });
    } else if (this.router.url.includes('FleetsB2c')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.FleetsB2c, index: TabIndex.FleetB2cUsers });
    } else if (this.router.url.includes('organizations')) {
      this.tabNavigationService.activatedTab$.next({ group: TabGroup.Organization, index: TabIndex.OrganizationUsers });
    }
  }

}
